import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { LegendItemAPI } from './legend-item-api.js';
import { LegendItemProperties } from './legend-item-types.js';
import { LegendItem } from './legend-item.js';
const awesomeProps = {
    api: LegendItemAPI,
    name: 'LegendItem',
    properties: LegendItemProperties,
    type: ComponentType.DATA_DISPLAY,
};
AwesomeComponent(awesomeProps)(LegendItem);
export { LegendItem, LegendItemAPI, };
export * from './legend-item-types.js';
//# sourceMappingURL=index.js.map